import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
  Box,
  TextField,
  DialogActions,
  Button
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useContext, useState } from "react";
import axios from "axios";
import { UserContext } from "../contexts/UserContext";

interface IProps {
  open: boolean;
  onClose: () => void;
  url: string;
  destinationEmail: string;
  subject: string;
  placeholder?: string;
}

export default function FeedbackModal({ open, onClose, url, destinationEmail, subject, placeholder }: IProps) {
  const { user } = useContext(UserContext);
  const [note, setNote] = useState("");
  const [feedbackSent, setFeedbackSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (note: string) => {
    const userEmail = user?.email;
    const userName = user?.name;
    setSubmitting(true);
    const url = window.location.href;
    await axios.post("/api/clientphonebook/contacts/sendFeedbackEmail", {
      url,
      note,
      userEmail,
      userName,
      destinationEmail,
      subject
    });
    setNote("");
    setFeedbackSent(true);
    setTimeout(() => {
      setFeedbackSent(false);
      onClose();
    }, 1500);
    setSubmitting(false);
  };
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        <Typography variant="subtitle1" marginBottom={3}>
          Submit Update
        </Typography>
      </DialogTitle>

      <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500]
        }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent sx={{ paddingBottom: 3 }}>
        <Box display="flex" flexDirection="column" gap={2}>
          {feedbackSent ? (
            <Typography
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 18
              }}
            >
              Updated!
            </Typography>
          ) : (
            <TextField
              label={placeholder ? placeholder : "Update"}
              multiline
              rows={4}
              value={note}
              onChange={(e) => setNote(e.target.value)}
              fullWidth
            />
          )}
        </Box>
        <Box paddingTop={1}>
            <Typography variant="subtitle2" color="text.secondary">
              Current Page
            </Typography>
            <Typography variant="body1">{url}</Typography>
          </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="inherit" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="soft" disabled={submitting || feedbackSent} onClick={() => onSubmit(note)}>
          {submitting ? "Submitting..." : "Submit"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
